import Page from 'src/player/sdk/index';

export default Page;
